import { protectedRoute } from "@/lib/protectedRoute";
import { Dashboard } from "@/pages/Dashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/analytics")({
  component: Dashboard,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
});
